import Vue from 'vue'
import Toast from './toast.vue'

const ToastConstructor = Vue.extend(Toast)
let instance = null

export function initToast() {
  if (!instance) {
    instance = new ToastConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(instance.$el)
  }
}

const toast = function (options) {
  initToast()
  instance.show(options)
}

// 快捷写法
toast.success = (msg) => toast({ message: msg, icon: 'success' })
toast.error = (msg) => toast({ message: msg, icon: 'error' })
toast.loading = (msg) => toast({ message: msg || '加载中...', icon: 'loading' })
toast.hide = () => instance && instance.hide()

export default toast


// WEBPACK FOOTER //
// ./src/components/toast/index.js